import React from 'react';
import { ArrowRightIcon, BanknoteIcon, SendIcon, ShieldCheckIcon } from 'lucide-react';
import { LandingHeader } from '../components/LandingHeader';
import { GettingStarted } from '../components/landing/GettingStarted';
import { HeroPaidStamps } from '../components/landing/HeroPaidStamps';
import { IntegrationsSection } from '../components/landing/IntegrationsSection';
import { InvoiceFlowPanel } from '../components/landing/InvoiceFlowPanel';
import { LatePaymentStats } from '../components/landing/LatePaymentStats';
import { SolutionsSection } from '../components/landing/SolutionsSection';
import { VideoSection } from '../components/landing/VideoSection';
const painPoints = [{
  icon: ShieldCheckIcon,
  title: 'Know who you are trusting',
  description: 'Monitor and manage your credit risk for existing and future customers.'
}, {
  icon: SendIcon,
  title: 'Get paid 4.4x faster',
  description: 'Automate payment chasing, to get paid 4.4 x faster, on average.'
}, {
  icon: BanknoteIcon,
  title: 'Unlock cash on demand',
  description: 'Unlock cash with fast, flexible invoice finance.'
}];
export function LandingPage() {
  return <div id="top" className="min-h-screen w-full bg-white text-[#041F60]" data-id="element-684" data-mp="38j3kiy6nu7wk">
      <a href="#main-content" className="sr-only fixed left-4 top-4 z-50 rounded-lg bg-[#041F60] px-4 py-2 text-sm font-bold text-white focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-[#4BE4FF]" data-id="element-685" data-mp="3dabsdpscdl7m">
        Skip to content
      </a>
      <LandingHeader current="/" data-id="element-686" data-mp="3n6ok4i4btozq" />

      <main id="main-content" data-id="element-687" data-mp="3ra39w0i2hjqd">
        <section className="relative isolate overflow-hidden bg-[#1c2229]" data-id="element-688" data-mp="3rb61kan7rq7c">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/13679fb7-233c-4253-8c9d-7b06ba440351.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-689" data-mp="4botfj5cxaf" />
          <HeroPaidStamps data-id="element-690" data-mp="21x9a8qalgnlc" />
          <div aria-hidden="true" className="absolute inset-0 bg-[#0b1118]/45" data-id="element-691" data-mp="355styqkxrvea" />
          <div className="relative mx-auto flex min-h-[30rem] max-w-4xl flex-col items-center justify-center px-5 py-24 text-center sm:px-8 sm:py-32 lg:min-h-[38rem]" data-id="element-692" data-mp="307ivo73x0eog">
            <h1 className="font-display text-[2rem] font-bold leading-[1.22] text-white drop-shadow-[0_2px_18px_rgba(0,0,0,0.5)] sm:text-[2.9rem] lg:text-[3.4rem]" data-id="element-693" data-mp="3e4eayharf2cy">
              Improve Your Cashflow by Reducing The Risk of Bad Debts and
              Getting Paid Quicker
            </h1>
            <a href="#benefits" className="font-display mt-11 inline-block bg-white px-10 py-4 text-[13px] font-bold uppercase tracking-[0.13em] text-[#041F60] transition-colors duration-150 hover:bg-[#4BE4FF] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#0b1118]" data-id="element-694" data-mp="3j3r3niobb3ng">
              Find out more
            </a>
          </div>
        </section>

        <section id="benefits" className="scroll-mt-6 bg-[#F2EFEC]" data-id="element-695" data-mp="pd0ivhunfnlx">
          <div className="mx-auto max-w-6xl px-5 py-20 text-center sm:px-8 sm:py-24" data-id="element-696" data-mp="panzd098t56r">
            <h2 className="font-display text-2xl font-extrabold uppercase leading-tight tracking-[0.01em] text-[#111827] sm:text-[2.3rem]" data-id="element-697" data-mp="ub2a4q28at8h">
              Remove the pain of poor cash flow
            </h2>
            <p className="mx-auto mt-7 max-w-2xl text-base leading-8 text-[#3A3A3A] sm:text-lg" data-id="element-698" data-mp="kfqum5izxhzo">
              Our 3 in 1 solution helps businesses to alleviate the stress of
              cash flow management by reducing the risk of bad debt and
              automating the processes that ensure you to get paid faster.
            </p>

            <ul className="mt-14 grid gap-6 sm:grid-cols-3" data-id="element-699" data-mp="1mmxubahep0u">
              {painPoints.map(point => <li key={point.title} className="flex h-full flex-col items-center border border-stone-300/70 bg-white px-7 py-9 text-center" data-id="element-700" data-mp="3js9hd2qw37aj">
                  <span className="grid h-12 w-12 place-items-center bg-[#041F60] text-[#4BE4FF]" data-id="element-701" data-mp="3grpqedsho9yu">
                    <point.icon size={21} aria-hidden="true" data-id="element-702" data-mp="3brjycwib4lg8" />
                  </span>
                  <h3 className="font-display mt-6 text-base font-bold uppercase tracking-[0.06em] text-[#041F60]" data-id="element-703" data-mp="3713iz6uxepr8">
                    {point.title}
                  </h3>
                  <p className="mt-3 text-sm leading-6 text-[#3A3A3A]" data-id="element-704" data-mp="320ft4oifoeyl">
                    {point.description}
                  </p>
                </li>)}
            </ul>

            <a href="/signup" className="mt-12 inline-block rounded-full bg-[#041F60] px-10 py-4 text-base font-bold text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 focus:ring-offset-[#F2EFEC]" data-id="element-705" data-mp="2t0ao2l0ppsnl">
              Get Started
            </a>
          </div>
        </section>

        <VideoSection data-id="element-706" data-mp="hcueojgf7a1f" />

        <section className="border-y border-stone-200 bg-stone-50" data-id="element-707" data-mp="pt1uejzlps4y">
          <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 sm:py-20 lg:grid-cols-[0.85fr_1.15fr] lg:items-center lg:gap-16" data-id="element-708" data-mp="pstgqpvnmisp">
            <div data-id="element-709" data-mp="ylnblvnl3qro">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-710" data-mp="yl3sibm76wc2">
                Automated chasing
              </p>
              <h2 className="font-display mt-3 text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-711" data-mp="13jow8l0nry59">
                Overdue invoices clear themselves
              </h2>
              <p className="mt-5 text-base leading-7 text-[#3A3A3A]" data-id="element-712" data-mp="aw2pj3w4wde6">
                Your reminder sequences run in the background, escalating on
                your terms until each invoice is settled — so the overdue
                balance falls without anyone picking up the phone.
              </p>
            </div>
            <InvoiceFlowPanel data-id="element-713" data-mp="1w95hmypv2erz" />
          </div>
        </section>

        <LatePaymentStats data-id="element-714" data-mp="1w7knha7gkxun" />
        <SolutionsSection data-id="element-715" data-mp="1ways6p3lhj59" />
        <GettingStarted data-id="element-716" data-mp="16kgtxc7vjodd" />
        <IntegrationsSection data-id="element-717" data-mp="16joz43m3puo5" />

        <section className="navy-texture border-t border-[#031849] text-white" data-id="element-718" data-mp="16n30p9mxxzuj">
          <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-5 py-14 sm:px-8 sm:py-20 md:flex-row md:items-center" data-id="element-719" data-mp="11ldmjl4f9628">
            <div className="max-w-xl" data-id="element-720" data-mp="1bkcqwri5mfjf">
              <h2 className="font-display text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-721" data-mp="1ble8letoe0a4">
                Get started now
              </h2>
              <p className="mt-3 text-base leading-7 text-[#A6B6F8]" data-id="element-722" data-mp="iw72nurw68eu">
                Start your free trial and bring credit, collections and invoice
                finance into one practical view.
              </p>
            </div>
            <a href="/signup" className="font-display inline-flex shrink-0 items-center gap-2 bg-[#4BE4FF] px-9 py-4 text-[13px] font-bold uppercase tracking-[0.13em] text-[#041F60] transition-colors duration-150 hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-723" data-mp="ss0kntodqu40">
              Start your free trial{' '}
              <ArrowRightIcon size={16} aria-hidden="true" data-id="element-724" data-mp="2gl2rv8mj0k08" />
            </a>
          </div>
        </section>
      </main>

      <footer className="border-t border-stone-200 bg-white" data-id="element-725" data-mp="26t6iv2iwj9h8">
        <div className="mx-auto flex max-w-6xl flex-col gap-5 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-726" data-mp="26tq3iqzxsbyy">
          <p className="text-sm font-semibold text-[#041F60]" data-id="element-727" data-mp="2zhu8faaool0l">Credit Manager</p>
          <a href="mailto:support@creditmanager.co.uk" className="text-sm font-semibold text-[#5B5299] underline decoration-[#A6B6F8] underline-offset-4 transition hover:text-[#041F60] focus:text-[#041F60] focus:outline-none" data-id="element-728" data-mp="2zfrkcvt3d1yi">
            Contact support
          </a>
          <p className="text-xs text-stone-500" data-id="element-729" data-mp="1a50jov4r19ac">© 2026 Credit Manager</p>
        </div>
      </footer>
    </div>;
}